import { render, staticRenderFns } from "./AssessmentModeOptionCard.vue?vue&type=template&id=530bb744&scoped=true"
import script from "./AssessmentModeOptionCard.vue?vue&type=script&lang=js"
export * from "./AssessmentModeOptionCard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentModeOptionCard.vue?vue&type=style&index=0&id=530bb744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530bb744",
  null
  
)

export default component.exports